import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c7e8b19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "color-gold ts-vic" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["textContent"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "tnc-content" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_10 = ["textContent"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "reg" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "reg-content"
}
const _hoisted_13 = ["textContent"]
const _hoisted_14 = ["textContent"]
const _hoisted_15 = {
  key: 0,
  class: "card-wrapper"
}
const _hoisted_16 = ["textContent"]
const _hoisted_17 = { class: "cards" }
const _hoisted_18 = ["textContent"]
const _hoisted_19 = ["textContent"]
const _hoisted_20 = { class: "tnc-wrapper" }
const _hoisted_21 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, "Times Square " + _toDisplayString($setup.typeText), 1),
      ($props.type === 1)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: $setup.bvicNotice,
            alt: "BVIC Notice",
            style: {"width":"100%"}
          }, null, 8, _hoisted_3))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.about, (obj, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "vic-content"
          }, [
            _createElementVNode("h3", {
              class: "vic-content-header",
              textContent: _toDisplayString(obj[0])
            }, null, 8, _hoisted_5),
            _createElementVNode("h4", {
              class: "vic-content-content",
              innerHTML: obj[1]
            }, null, 8, _hoisted_6)
          ]))
        }), 128))
      ]),
      _createElementVNode("h4", _hoisted_7, [
        _createElementVNode("u", {
          class: "pe-pointer text-blue",
          textContent: _toDisplayString(_ctx.$t('tnc-apply')),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onModalOpen && $setup.onModalOpen(...args)))
        }, null, 8, _hoisted_8),
        _hoisted_9,
        _createElementVNode("span", {
          textContent: _toDisplayString($setup.tnc)
        }, null, 8, _hoisted_10)
      ]),
      _hoisted_11,
      ($props.type !== 1)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_12, [
            _createElementVNode("span", {
              textContent: _toDisplayString(_ctx.$t('registration-at') + ':')
            }, null, 8, _hoisted_13),
            _createElementVNode("span", {
              textContent: _toDisplayString($setup.reg)
            }, null, 8, _hoisted_14)
          ]))
        : _createCommentVNode("", true)
    ]),
    ($props.type === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("h2", {
            class: "color-gold ts-tier",
            textContent: _toDisplayString(_ctx.$t('member-tier'))
          }, null, 8, _hoisted_16),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.vicCards, (c, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card-container",
                key: i
              }, [
                _createVNode(_component_SvgIcon, {
                  "icon-name": c.image,
                  class: "card-image"
                }, null, 8, ["icon-name"]),
                _createElementVNode("h3", {
                  class: "card-name",
                  textContent: _toDisplayString(c.title)
                }, null, 8, _hoisted_18),
                _createElementVNode("h6", {
                  class: "card-subtitle",
                  textContent: _toDisplayString(_ctx.$t(c.subtitle))
                }, null, 8, _hoisted_19)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Modal, {
      open: $setup.modalOpen,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => (($setup.modalOpen) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", {
            class: "tnc-doc",
            innerHTML: $setup.tncDoc
          }, null, 8, _hoisted_21)
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}